const callbacks = new WeakMap();

const observer = new IntersectionObserver((entries) => {
  entries
    .filter(entry => entry.isIntersecting)
    .forEach(entry => {
      const callback = callbacks.get(entry.target);

      callback(entry);
    });
}, {
  root: null,
  threshold: 0.2
});

export function observe(el, callback) {
  callbacks.set(el, callback);
  observer.observe(el);

  return () => {
    observer.unobserve(el);
  };
}
